import ChatDetail from '@/screens/ChatDetail';

export default function PrivateTabsChatChatIdIndexRoute() {
  return <ChatDetail />;
}
